import React, {useEffect, useState, useRef} from 'react';
import { HiArrowLeft } from "react-icons/hi2";
import {FaCamera} from "react-icons/fa";
import { Navbar, Button } from 'flowbite-react';
import bike from "../img/bike.png";
import car from "../img/car-placeholder.svg";
import { Upload } from 'antd';
import { documentsWasUpdatedByUser } from "../utils/updatedByUser"
import {
  useSearchParams, useNavigate
} from "react-router-dom";
import { ONBOARDING_API_ENDPOINT } from "../config/url.config";
import { getVehicleMakes, getVehicleModels } from "../services/ondemandApi"
import axios from "axios"
import moment from "moment"
import { MdCheckCircle } from "react-icons/md";
import { BsThreeDots } from "react-icons/bs";
import {  handleImageUpload } from "./handler";
import { navigateToSessionExpired } from "../utils/sessionExpired";
import { getAuthHeader } from "../utils/superFetch";

const VihicleDetails = (props) => {
  const cssForImageCard = {
    success : {
      imageDiv: 'mt-2 mb-10 custom-card-success border rounded-md items-center shadow-none p-10',
    },
    standard : {
      imageDiv: 'mt-2 mb-10 custom-card border rounded-md items-center shadow-none p-10',
    }
  }
  const navigate = useNavigate();
  // let [searchParams, setSearchParams] = useSearchParams()
  // const token = searchParams.get("token")
  const selectedProfileType = JSON.parse(sessionStorage.getItem("selectedProfileType"));
  const transportType = JSON.parse(sessionStorage.getItem("transportType"));
  const [vehiclePicture, setVehiclePicture] = useState("")
  let [validation, setValidation] = useState({ show: false , message: "", class:""});
  let [validationOnSubmit, setValidationOnSubmit] = useState({ show: false , message: "", class:""});
  const [vehicalDetails, setVehicalDetails] = useState({
    brand:"",
    model:"",
    vehicleNumber:"",
  })
  const [vehicleMakes, setVehicleMakes] = useState([])
  const [models, setModels] = useState([])
  const vehicleImageRef = useRef(null);
  let [userUploadedVehiclePic, setUserUploadedVehiclePic] = useState(false)
  let [vehiclePicLoading, setVehiclePicLoading] = useState(false)
  let [submitButtonState, setButtonState] = useState(true)
  let [loadModels, setLoadModels] = useState(true)
  let [userUpdatedData, setUserUpdatedData] = useState(false)
  
 useEffect(()=>{
  setVehiclePicture(transportType !== 1 ? bike : car)
  let savedBrand = ""
  let savedModel = ""
  for(let requiredItems of props.memberRequirement.requiredDocuments[props.itemIndex].requiredItems) {
    
    if (requiredItems.value !== "" && requiredItems.itemName === 'brand') {
      savedBrand = requiredItems.value
      setVehicalDetails(vehicalDetails => ({...vehicalDetails, brand: requiredItems.value}))
      setLoadModels(false)
    }
    if (requiredItems.value !== "" && requiredItems.itemName === 'model') {
      savedModel = requiredItems.value
      setVehicalDetails(vehicalDetails => ({...vehicalDetails, model: requiredItems.value}))
    }
    if (requiredItems.value !== "" && requiredItems.itemName === 'vehicleNumber') {
      setVehicalDetails(vehicalDetails => ({...vehicalDetails, vehicleNumber: requiredItems.value}))
    }
    if (requiredItems.value !== "" && requiredItems.itemName === "carPlateNumber") {
      setVehicalDetails(vehicalDetails => ({...vehicalDetails, vehicleNumber: requiredItems.value}))
    }

    if(requiredItems.itemName === 'vehiclePicture' && requiredItems.value !== "") {
      setVehiclePicture(requiredItems.url)
      setUserUploadedVehiclePic(true)
    }
  }
  setVehicleBrands(savedBrand)
  if (savedBrand) {
    setVehicleModels(savedBrand, savedModel)
  }
  setUserUpdatedData(false)
 }, [])

 const handleVehicleImageClick = () => {
  vehicleImageRef.current.click();
}

  const setVehicleBrands = async (currentMake) =>{
      try {
        let response = await getVehicleMakes()
        let vehicleMakesList = (response.result || []).map((e)=>{
          return e.make
        }).filter(Boolean)
        if (currentMake && !vehicleMakesList.includes(currentMake)) {
          vehicleMakesList = [currentMake, ...vehicleMakesList]
        }
        setVehicleMakes(vehicleMakesList)
      } catch (err) {
        if (currentMake) {
          setVehicleMakes([currentMake])
          return
        }
        navigateToSessionExpired(navigate, {
          reason: "vehicle_makes_load_failed",
          source: "setVehicleBrands",
          component: "VehicleDetails",
          status: err?.response?.status,
          message: err?.message,
        })
      }
  }

  const setVehicleModels = async (vehicleMake, currentModel) => {
    try {
      let response = await getVehicleModels(vehicleMake)
      let modelsList = (response.result || []).map((e)=>{
        return e.model
      }).filter(Boolean)
      if (currentModel && !modelsList.includes(currentModel)) {
        modelsList = [currentModel, ...modelsList]
      }
      setModels(modelsList)
    } catch (err) {
      setModels(currentModel ? [currentModel] : [])
    }
  }

  const validateOnChange = () => {
    if (validationOnSubmit.show && vehicalDetails.brand === '') {
      setValidationOnSubmit({ show: true , message: "Select the brand of you're vehicle", class:"error-msg"})
      return 
    }
    else if (validationOnSubmit.show && vehicalDetails.model === '') {
      setValidationOnSubmit({ show: true , message: "Select the model of you're vehicle", class:"error-msg"})
      return 
    }
    else if (validationOnSubmit.show && vehicalDetails.vehicleNumber === '') {
      setValidationOnSubmit({ show: true , message: "Provide a valid License Number", class:"error-msg"})
      return 
    }
    else if (validationOnSubmit.show && !userUploadedVehiclePic) {
      setValidationOnSubmit({ show: true , message: "Missing image of you're vehicle", class:"error-msg"})
      return 
    } else {
      setValidationOnSubmit({ show: false , message: "", class:""})
      return 
    }
  }

  const handleFileChange = async (e, itemName) => {
    let file = e.target.files[0]
    if (!["image/png", "image/jpeg", "image/jpg"].includes(file.type) || file.size/1000000 > 7 ) {
      setValidation({ show: true , message: "Invalid image. Only images of type png, jpg, jpeg with size below 7mb can be uploaded", class:"error-msg"})
    return
  }
    setVehiclePicLoading(true)
    await handleImageUpload(file, itemName, "vehicleDetails", 
    setVehiclePicture, setValidation, setUserUploadedVehiclePic,
    setButtonState, props.memberRequirement,props.setMemberRequirement, props.itemIndex, navigate, selectedProfileType.profileId)
      setVehiclePicLoading(false)
   
  }

  const handleSaveInformation = async () => {
    if (!userUpdatedData) {
      props.setOpenUploadDocument({openDocument : false , documentType : ""})
      return
    }
    
    if (vehicalDetails.brand === '') {
      setValidationOnSubmit({ show: true , message: "Select the brand of you're vehicle", class:"error-msg"})
      return 
    }
    if (vehicalDetails.model === '') {
      setValidationOnSubmit({ show: true , message: "Select the model of you're vehicle", class:"error-msg"})
      return 
    }
    if (vehicalDetails.vehicleNumber === '') {
      setValidationOnSubmit({ show: true , message: "Provide a valid License Number", class:"error-msg"})
      return 
    }
    if (!userUploadedVehiclePic) {
      setValidationOnSubmit({ show: true , message: "Missing image of you're vehicle", class:"error-msg"})
      return 
    }

    let body = {
      item : "vehicleDetails" ,
      requiredItems: [
        {
          itemName: 'brand' ,
          value: vehicalDetails.brand
        },
        {
          itemName: 'model' ,
          value: vehicalDetails.model
        },
        {
          itemName: 'vehicleNumber' ,
          value: vehicalDetails.vehicleNumber
        },
      ]
    }
    const config = {
      headers: { "content-type": "application/json", "upload-document": false , ...getAuthHeader() },
    };

    try {
      const res = await axios.post(
        `${ONBOARDING_API_ENDPOINT}/api/onboarding/updateConfiguration?profileType=${selectedProfileType.profileId}`,
        body,
        config
      );
      if (res.status) {

     let tmpMemberData = {...props.memberRequirement}
    
     for (let i =0 ; i < tmpMemberData.requiredDocuments[props.itemIndex].requiredItems.length ;i++) {
        if (tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i].itemName in vehicalDetails) {
          if(tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i].status === 2 || 
            tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i].value !== '') {
            documentsWasUpdatedByUser(`${tmpMemberData.requiredDocuments[props.itemIndex].item}`)
          }

          tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i].value = vehicalDetails[`${tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i].itemName}`]
          tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i].uploadedTime = moment.unix()
          
        } 
      }
        props.setMemberRequirement(tmpMemberData)
        props.setOpenUploadDocument({openDocument : false , documentType : ""})
      }
  
    } catch (error) {
      console.log("Error message", error.message)
    }
  }

  const updateButtonState =  () => {
    for (const key in vehicalDetails) {
      if (vehicalDetails[`${key}`] === "") {
        setButtonState(true)
        return
      }
    }
    setButtonState(false)
    
  }


  return (
    <>
    <Navbar
        fluid={true}
        rounded={true}
        className='shadow mb-3' style={{position:'fixed', width:'100%', top:'0'}}>  
            <Navbar.Brand onClick={()=>{props.setOpenUploadDocument({openDocument : false , documentType : ""})}}>
                  <HiArrowLeft className='h-10 w-5 ml-2' />
            </Navbar.Brand>
      </Navbar>
    <div className='p-6  max-w-md m-auto' style={{paddingTop:'80px'}}>
        
        <h5 className="text-2xl mb-2 font-bold tracking-tight text-gray-900 dark:text-white">
        Vehicle Details
        </h5>
        <p className='mb-8 text-gray-600'>Below are the required document to setup Rydesend account.</p>

        { validationOnSubmit.show &&
                  
                  <div className={validationOnSubmit.class}>
                      <span >{validationOnSubmit.message}</span>
                  </div>
              
              }

        <div className="col-span-6 sm:col-span-3 mb-8">
            <label htmlFor="Model" className="block text-sm font-medium text-gray-700">
                Make
            </label>
            <select
                id="Model"
                name="Model"
                autoComplete="Model"
                className="mt-1 block w-full rounded-md border border-gray-300 bg-white py-2 px-3 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                onChange={(e) => {
                    setUserUpdatedData(() => true)
                    setVehicalDetails(vehicalDetails=> ({...vehicalDetails, brand: e.target.value}));
                    setVehicleModels(e.target.value)
                    setLoadModels(false);
                     validateOnChange();
                  }}
                defaultValue={vehicalDetails.brand}
                value={vehicalDetails.brand}
                >
                {
                  vehicleMakes && 
                  (<>
                    <option value={""} disabled>
                      
                    </option>
                    {
                        vehicleMakes.map((make) => {
                          return (
                            <>
                              <option value={make}>{make}</option>
                            </>
                          )
                      })
                    }
                 
                 
                  </>)
                }
            </select>
        </div>
        <div className="col-span-6 sm:col-span-3 mb-8">
            <label htmlFor="Model" className="block text-sm font-medium text-gray-700">
                Model
            </label>
            <select
                id="Model"
                name="Model"
                autoComplete="Model"
                className="mt-1 block w-full rounded-md border border-gray-300 bg-white py-2 px-3 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                onChange={(e) => { setUserUpdatedData(() => true); setVehicalDetails(vehicalDetails=> ({...vehicalDetails, model: e.target.value})); updateButtonState(); validateOnChange(); }  }
                defaultValue={vehicalDetails.model}
                value={vehicalDetails.model}
                disabled={loadModels}
                >
                {
                  models && 
                  (<>
                    <option value={""} disabled>
                      
                    </option>
                    {
                        models.map((model) => {
                          return (
                            <>
                              <option value={model}>{model}</option>
                            </>
                          )
                      })
                    }
                 
                 
                  </>)
                }
            </select>
        </div>

        {
          userUploadedVehiclePic && 
          <div className="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white" style={{paddingRight: '10px'}}>
            <MdCheckCircle style = {{ color: '#15BE44' }}/>
          </div>
        }
        <label className='font-bold tracking-tight text-gray-900'>Vehicle Image</label>
        
        <div className={ userUploadedVehiclePic ?  cssForImageCard.success.imageDiv : cssForImageCard.standard.imageDiv}>
        { validation.show &&
                  
                  <div className={ validation.class}>
                      <span >{validation.message}</span>
                  </div>
              
              }
                <img src={vehiclePicture}
            className="w-auto m-auto"
            alt="Ryde" />
            <p className='text-xs text-gray-400 tracking-tight mt-2'><i>• Ensure license plate number is visible. <br />
            • This will be in your public profile.</i></p>
            
            <Button  pill={true} className='mt-5 m-auto w-sm pr-4' onClick={handleVehicleImageClick}>
            {
              vehiclePicLoading ? <BsThreeDots className="h-5 w-10" /> : <FaCamera className="h-5 w-10" />
            }
              <label //for="file-upload" 
              className="relative cursor-pointer rounded-md font-medium">
                <span>{vehiclePicLoading ? 'Saving' : userUploadedVehiclePic ? 'Replace' : 'Upload' }</span>
                      
              </label> 
            </Button>
            <input 
            id="file-upload" 
            name="file-upload"
            type="file"
           style={{display: 'none', width:'0px',}}
           ref={vehicleImageRef}
            onChange={(event)=>{handleFileChange(event,"vehiclePicture");  validateOnChange(); setUserUpdatedData(() => true) }}/>
            
        </div>
        

        <div className="col-span-6 mb-8">
          <label htmlFor="name" className="block text-sm font-medium text-gray-700">
            License Number
          </label>
          <input
            type="text"
            name="contact-number"
            placeholder='e.g SMKXXXXD'
            id=""
            autoComplete=""
            value={vehicalDetails.vehicleNumber}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            // onChange={(e) => {setVehicalDetails({...vehicalDetails, vehicleNumber: e.target.value})}}
            onChange={(e) => { setUserUpdatedData(() => true); setVehicalDetails(vehicalDetails=> ({...vehicalDetails, vehicleNumber: e.target.value})); updateButtonState() ; validateOnChange();}  }
          />
        </div>
        <Button className='bg-primary w-full mt-5' pill={true} disabled={false} onClick={handleSaveInformation}>
          Save
        </Button>
        
    </div>
   
    </>
  )
}

export default VihicleDetails;